// extracted by mini-css-extract-plugin
export default {"container":"QuoteNettoBetListItemOverview_container__qY2dJ"};